import {
    useDispatch,
    useSelector
} from 'react-redux';

import { changeConsent } from '../actions/consents';
import { clinicCapabilitiesMapping } from '../agreementsConfig';
import { getUserInfo } from '../selectors';
import {
    getClinics,
    getConsentProviders,
    getConsents,
    getConsentsForAllProviders
} from '../selectors/consents';

// USER_AGREEMENT, STORE_PROFILE_CHILD, MEDICAL_DATA_HISTORY_CHILD, MEDICAL_DATA_HISTORY, MEDICAL_DATA_HISTORY_CLINIC, ONLINE_BOOKING_CHILD_CLINIC, ONLINE_BOOKING_CLINIC, MEDICAL_DATA_HISTORY_CHILD_CLINIC

export const USER_AGREEMENT_KEY = 'USER_AGREEMENT';

export const STORE_PROFILE_CHILD = 'STORE_PROFILE_CHILD';

export const ONLINE_BOOKING_CLINIC = 'ONLINE_BOOKING_CLINIC';
export const ONLINE_BOOKING_CHILD_CLINIC = 'ONLINE_BOOKING_CHILD_CLINIC';

export const USER_HISTORY_KEY = 'MEDICAL_DATA_HISTORY';
export const USER_CLINIC_HISTORY_KEY = 'MEDICAL_DATA_HISTORY_CLINIC';

export const CHILD_HISTORY_KEY = 'MEDICAL_DATA_HISTORY_CHILD';
export const CHILD_CLINIC_HISTORY_KEY = 'MEDICAL_DATA_HISTORY_CHILD_CLINIC';

export const FEEDBACK_AUTHOR_NAME = 'FEEDBACK_AUTHOR_NAME';
export const CHILD_CONSENT_LIST = [
    CHILD_HISTORY_KEY,
    CHILD_CLINIC_HISTORY_KEY,
    ONLINE_BOOKING_CHILD_CLINIC,
    STORE_PROFILE_CHILD,
];

export const USER_CONSENT_LIST = [ USER_AGREEMENT_KEY,
    USER_HISTORY_KEY,
    USER_CLINIC_HISTORY_KEY,
    FEEDBACK_AUTHOR_NAME,
    ONLINE_BOOKING_CLINIC ];

export const isConsentProvided = ({
    profileId,
    consents,
    agreementKey,
    providerCode,
}) => {
    const profile = profileId && profileId !== consents?.profileId ? consents?.family?.[profileId] ?? {} : consents?.user ?? {};
    const consentsObject = agreementKey?.includes('CLINIC') ? profile?.[providerCode] ?? {} : profile?.main ?? {};
    return consentsObject?.[agreementKey];
};

export const isClinicHaveCapability = ({capabilities, providerCode, consent}) => {
    if (!providerCode) throw new Error('providerCode is required');
    if (!consent) throw new Error('consent is required');
    const cap = capabilities?.[providerCode];
    return cap?.some(item => clinicCapabilitiesMapping?.[item]?.main === consent || clinicCapabilitiesMapping?.[item]?.family === consent);
}

export const usePersonalData = () => {
    const cons = useSelector(getConsents);
    const allConsents = useSelector(getConsentsForAllProviders);
    const dispatch = useDispatch();
    const userInfo = useSelector(getUserInfo);
    const providers = useSelector(getConsentProviders);
    const clinics = useSelector(getClinics);

    return {
        consents: cons,
        providers,
        clinics,
        cons,
        changeConsent,
        dispatch,
        userInfo,
        family: userInfo?.relatives,
        familyObject: userInfo?.relatives?.reduce?.((acc, p) => {
            return {
                ...acc,
                [p?.profileId]: p,
            };
        }, {}),
        isLoading: cons?.isLoading,
        offline: cons?.providerErrors ?? [],
        allConsents,
    };
};
